import axios from "axios";
import authHeader from "@/services/utils/auth-header";

const API_URL = '/OppPortal/api/v1/cache/';

class CacheService {

    clearAll() {
        return axios.delete(API_URL + `clear`, {headers: authHeader()});
    }

    clearPortal(name, deep) {
        return axios.delete(API_URL + `clear/portal/${name}?deep=${deep}`, {headers: authHeader()});
    }

    clearClientMonitoring(id) {
        return axios.delete(API_URL + `clear/client/${id}/monitoring`, {headers: authHeader()});
    }
}

export default new CacheService();